<template>
  <div>
    <div class="d-flex justify-content-center align-items-center">
      <div>
        <b-button
          variant="secondary"
          class="btn-icon rounded-circle p-3"
          size="sm"
          v-on:click="onOptionDetailBidder(bidder)"
          data-cy="details"
        >
          <feather-icon icon="SearchIcon"/>
        </b-button>
      </div>
      <slot
        name="action-list"
        v-bind:receipt="bidder"
      >
        <div v-tooltip="'Desplegar acciones'">
          <b-dropdown
            v-has-permission="'ED212'"
            variant="link"
            no-caret
            right
          >
            <template #button-content>
              <feather-icon
                width="24px"
                height="24px"
                data-cy="gear-button"
                icon="SettingsIcon"
                class="align-middle text-body"
              />
            </template>
            <CheckPermission permission="*">
              <b-dropdown-item
                v-on:click="onOptionBinnacleBidder(bidder)"
                data-cy="binnacle-bidder"
              >
                <vs-icon icon="person"/>
                Bitácora
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission permission="ED213">
              <b-dropdown-item
                v-on:click="onOptionEditBidder(bidder)"
                data-cy="edit-bidder"
              >
                <vs-icon icon="person"/>
                Editar adjudicatario
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission permission="ED213">
              <b-dropdown-item
                v-if="bidder.estadoActivo === biddersStateCode.activo"
                v-on:click="onOptionDeactivateBidder(bidder)"
                data-cy="deactivate-bidder"
              >
                <vs-icon icon="remove_circle"/>
                Deshabilitar adjudicatario
              </b-dropdown-item>
            </CheckPermission>
          </b-dropdown>
          <span/>
        </div>
      </slot>
    </div>
    <b-modal
      :id="`bidder-detail-${bidder.adjudicatarioId}`"
      title="Detalles"
      no-close-on-backdrop
      :ref="`bidder-detail-${bidder.adjudicatarioId}`"
      size="lg"
      hide-footer
    >
      <DetailBidder :bidder="bidder"/>
    </b-modal>
    <b-modal
      title="Editar adjudicatario"
      no-close-on-backdrop
      :ref="`edit-bidder-${bidder.adjudicatarioId}`"
      size="lg"
      hide-footer
    >
      <BidderForm
        :actual-bidder="bidder"
        @bidder-save="handleBidderSave()"
      />
    </b-modal>
    <ModalBinnacle
      :title="`Bitácora del adjudicatario ${bidder.nombre}`"
      :id="`binnacle-${bidder.adjudicatarioId}`"
      :ref="`binnacle-${bidder.adjudicatarioId}`"
    />
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import CheckPermission from '@/febos/global/usuario/components/CheckPermission';
import DetailBidder from '@/febos/aduanas/successfulBidder/views/components/DetailBidder';
import BidderForm from '@/febos/aduanas/successfulBidder/views/components/BidderForm';
import ModalBinnacle from '@/febos/aduanas/binnacles/ModalBinnacle';
import { biddersStateCode } from '@/febos/aduanas/successfulBidder/views/utils/constans';
import { attemptDeactivateBidder } from '@/febos/aduanas/successfulBidder/store/actions';

export default {
  components: {
    CheckPermission,
    DetailBidder,
    BidderForm,
    ModalBinnacle
  },
  props: [
    'bidder',
    'selectBidder'
  ],
  data() {
    return {
      biddersStateCode
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUserId'
    ])
  },
  methods: {
    ...mapActions('Modals', [
      'showModals'
    ]),
    ...mapActions('successfulBidders', {
      attemptDeactivateBidder: attemptDeactivateBidder.name
    }),
    onOptionDetailBidder(bidder) {
      this.selectBidder(bidder);
      this.$refs[`bidder-detail-${this.bidder.adjudicatarioId}`].show();
    },
    onOptionBinnacleBidder(bidder) {
      this.selectBidder(bidder);
      this.$refs[`binnacle-${this.bidder.adjudicatarioId}`].show(bidder.adjudicatarioId);
    },
    onOptionEditBidder(bidder) {
      this.selectBidder(bidder);
      this.$refs[`edit-bidder-${this.bidder.adjudicatarioId}`].show();
    },
    async deactivateBidder(adjudicatarioId) {
      await this.attemptDeactivateBidder(adjudicatarioId);
      this.$vs.notify({
        title: 'Genial!',
        text: 'Se ha desactivado el adjudicatario exitosamente',
        color: 'success',
        time: 5000,
        position: 'top-center'
      });
    },
    onOptionDeactivateBidder(bidder) {
      this.selectBidder(bidder);
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Atención',
        text: `¿Estás seguro que deseas deshabilitar al adjudicatario ${this.bidder.nombre}?`,
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.deactivateBidder(this.bidder.adjudicatarioId)
      });
    },
    handleBidderSave(bidder) {
      this.$refs[`edit-bidder-${this.bidder.adjudicatarioId}`].hide();
      this.$emit('bidder-save', bidder);
    }
  }
};

</script>
